export default "__VITE_ASSET__Dg5ijE61__"